import { AnswerItem } from 'models/AnswerItem';
import iconAnswerCalendar from 'assets/icons/answers/icon_answer_calendar.svg';
import iconAnswerPercent from 'assets/icons/answers/icon_answer_percent.svg';
import iconAnswerIncompleteCircle from 'assets/icons/answers/icon_answer_incomplete_circle.svg';
import iconAnswerCreditCard from 'assets/icons/answers/icon_answer_credit_card.svg';
import iconAnswerMoney from 'assets/icons/answers/icon_answer_money.svg';
import iconAnswerDrive from 'assets/icons/answers/icon_answer_drive.svg';

export const CONVENTIONAL_CREDIT_TYPE: AnswerItem[] = [
	{
		title: 'Plazo',
		content: '6 a 60 meses*',
        icon: iconAnswerCalendar,
	},
    {
		title: 'Tasa',
		content: 'Fija mensual',
        icon: iconAnswerPercent,
	},
    {
		title: 'Pie',
		content: 'Mínimo 20%',
        icon: iconAnswerIncompleteCircle,
	},
    {
		title: 'Financiamiento',
		content: 'Autos con 7 años de antigüedad máxima',
        icon: iconAnswerCreditCard,
	},
    {
		title: 'Cuotas',
		content: 'Iguales durante todo el periodo',
        icon: iconAnswerMoney,
	},
];

export const SMART_CREDIT_TYPE: AnswerItem[] = [
	{
		title: 'Plazo',
		content: '24 o 36 meses+ cuotón*',
        icon: iconAnswerCalendar,
	},
    {
		title: 'Tasa',
		content: 'Fija mensual',
        icon: iconAnswerPercent,
	},
    {
		title: 'Pie',
		content: 'Mínimo 20% - Máximo 30%',
        icon: iconAnswerIncompleteCircle,
	},
    {
		title: 'Financiamiento',
		content: 'Autos con 2 años de antigüedad máxima',
        icon: iconAnswerCreditCard,
	},
    {
		title: 'Cuotas',
		content: 'Al final del periodo renueva tu auto o refinancia el cuotón*',
        icon: iconAnswerDrive,
	},
];
